import {
  SALES_PERSON_PREVIEW,
  SALES_PERSON_NEW,
  SALES_PERSON_UPDATE,
  SALES_PERSON_REMOVE,
  SALES_PERSON_SEARCH,
  SALES_PERSON_PROCESS_SUCCESS,
  SALES_PERSON_DATASOURCE_SUCCESS,
  SALES_PROCESS_RESET
} from "constants/ActionTypes"

const INIT_STATE = {
  loader: false,
  dataSerialize:{},
  dataSource:[],
  process:{},
  keyword:''
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SALES_PERSON_PREVIEW: {
      return {
        ...state,
        loader: false,
        process:{status:false,action:"",message:""}
      }
    }
    case SALES_PERSON_NEW: {
      return {
          ...state,
          loader: true,
          process:{status:false,action:"",message:""}
      }
    }
    case SALES_PERSON_UPDATE:{
        return{
          ...state,
          loader:true,
          process:{status:false,action:"",message:""},
          dataSerialize:action.payload
        }
    }
    case SALES_PERSON_REMOVE: {
      return {
          ...state,
          loader: false,
          process:{status:false,action:"",message:""}
      }
    }
    case SALES_PERSON_SEARCH:{
        return {
            ...state,
            loader:false,
            keyword:action.payload
        }
    }
    case SALES_PERSON_PROCESS_SUCCESS:{
      return{
        ...state,
        loader:false,
        process:action.payload
      }
    }
    case SALES_PERSON_DATASOURCE_SUCCESS:{
        return {
            ...state,
            loader: false,
            dataSource: action.payload
        }
    }
    case SALES_PROCESS_RESET:{
      return{
        ...state,
        process:{}
      }
    }
    default:
      return state
  }
}